<template>
  <v-container fluid>
    <h1>Ordernar</h1>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Tela inicial app</v-card-title>
          <v-row justify="center">
            <draggable
              v-model="prices"
              draggable=".item"
              class="row wrap justify-space-around"
              @end="onEnd"
            >
              <v-col
                cols="6"
                v-for="price in prices"
                :key="price.id"
                align="center"
                class="item"
              >
                <v-col>
                  <v-col class="subtitle pa-0">{{ price.product.name }}</v-col>
                  <v-col class="caption pa-0">{{ price.product.ean1 }}</v-col>
                </v-col>
                <v-col class="pa-0" height="125">
                  <v-card height="125" width="126" color="grey">
                    <v-img
                      :src="
                        `http://beta.applysys.com.br/img/produtos/webp/${price.product.ean1}.webp`
                      "
                      max-height="125"
                      contain
                    />
                  </v-card>
                </v-col>
              </v-col>
            </draggable>
          </v-row>
        </v-card>
      </v-col>
      <v-col>
        <v-virtual-scroll :items="pricesAll" height="600" :item-height="50">
          <template v-slot="{ item }">
            <v-list-item>
              {{ item.product.name }}
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import {
  GetFrontSaleProducts,
  ChangeOrderPricesFront,
  GetAllSaleProducts
} from "../../graphql/prices.gql";

export default {
  name: "ProductsOrder",
  components: {
    draggable
  },
  apollo: {
    prices: {
      prefetch: true,
      query: GetFrontSaleProducts,
      variables: {
        drugstore: 1
      }
    },
    pricesAll: {
      prefetch: true,
      query: GetAllSaleProducts,
      variables: {
        drugstore: 1
      }
    }
  },
  methods: {
    onEnd(e) {
      //console.log(this.prices[e.oldIndex]);
      this.$apollo.mutate({
        mutation: ChangeOrderPricesFront,
        variables: {
          id: this.prices[e.oldIndex].id,
          order: e.newIndex
        }
      });
    }
  }
};
</script>

<style></style>
